// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1o-o";
export var animationRelative = "_1o-n";
export var backdropBlur = "_1o-0";
export var detailLabelCell = "_1o-10";
export var detailTable = "_1o-z";
export var detailValueCell = "_1o-11";
export var docIconBox = "_1o-19";
export var docTypeRow = "_1o-14";
export var docTypeRowInner = "_1o-15";
export var dropdownMatchDatePicker = "_1o-1";
export var fileUploadSpin = "_1o-h";
export var gorgiasOpenButton = "_1o-13 _1o-b";
export var gorgiasTicketCard = "_1o-12";
export var heroModalFooterButton = "_1o-16";
export var hiddenContainer = "_1o-m";
export var maxWidthContainer = "_1o-17";
export var modalContentBody = "_1o-8";
export var modalHeaderImage = "_1o-3";
export var modalImageLabel = "_1o-5";
export var modalImageOverlay = "_1o-4";
export var modalImageSubtitle = "_1o-7";
export var modalImageTitle = "_1o-6";
export var modalImageWrapper = "_1o-2";
export var modalStickyFooter = "_1o-9";
export var removeButton = "_1o-c";
export var sidebarColumn = "_1o-18";
export var spinner = "_1o-g";
export var timelineLine = "_1o-w";
export var timelineLineBlack = "_1o-y _1o-w";
export var timelineLineGray = "_1o-x _1o-w";
export var timelineLineHeight = "_1o-v";
export var tlDotActivate = "_1o-s";
export var tlDotActivateAnim = "_1o-r";
export var tlDotHide = "_1o-q";
export var tlDotHideAnim = "_1o-p";
export var tlLineActivate = "_1o-u";
export var tlLineActivateAnim = "_1o-t";
export var uploadHint = "_1o-l";
export var uploadIconBox = "_1o-i";
export var uploadLabel = "_1o-k";
export var uploadText = "_1o-j";
export var uploadZone = "_1o-d";
export var uploadZoneCursorDefault = "_1o-f";
export var uploadZoneCursorPointer = "_1o-e";
export var uploadedFileRow = "_1o-a";
export var viewButton = "_1o-b";